export class Destinatario {
  public id: number;
  public codigo: string;
  public descripcion: string;
  public titulo: string;
  public target: string;
  public targetType: string;
  public fechaCreacion: string;
  public fechaActualizacion: string;
  public usuarioAutualizador: string;
  public habilitado: boolean;
  constructor(
    id: number,
    codigo: string,
    descripcion: string,
    titulo: string,
    targetType: string,
    target: string,
    fechaCreacion: string,
    fechaActualizacion: string,
    usuarioAutualizador: string,
    habilitado: boolean
  ) {
    this.id = id;
    this.codigo = codigo;
    this.descripcion = descripcion;
    this.titulo = titulo;
    this.fechaCreacion = fechaCreacion;
    this.fechaActualizacion = fechaActualizacion;
    this.usuarioAutualizador = usuarioAutualizador;
    this.target = target;
    this.targetType = targetType;
    this.habilitado = habilitado;
  }
}
